import { defineMessages } from 'react-intl'

export default defineMessages({
  login: {
    defaultMessage: 'Login',
  },
  logout: {
    defaultMessage: 'Logout',
  },
})
